module.exports = __webpack_public_path__ + "img/Shop2ulogo.386db72e.svg";